export default __webpack_public_path__ + "images/R6.04b8b97.png";